export function toHash(arr, key) {
  return arr.reduce((a,c) => {
    a[c[key]] = c;
    return a;
  }, {})
}
